export enum FileUploadType {
  Direct = 0,
  Azure = 1,
}
